import { ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { DatePipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { PTableCellValueComponent } from '@primeng/table/components/p-table-cell-value/p-table-cell-value.component';
import { SharedModule } from '@primeng/api';
import { Table } from '@primeng/table';
import { TranslatePipe } from '@ngx-translate/core';
import { Router, RouterLink } from '@angular/router';
import { idField, ReferenceField } from '@common/references/reference-field';
import { getResourceById, Resources } from '@app/resources';
import { BasicTableComponent } from '@common/references/basic-table.component';
import { SelectableRow } from '@primeng/table/directives/selectable-row.directive';
import {
  PersonalPropertyInfoComponent
} from '@modules/universal-billing/properties/property-profile/personal-property-info/personal-property-info.component';
import {
  NgbAccordionBody,
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective,
  NgbAccordionHeader,
  NgbAccordionItem
} from '@ng-bootstrap/ng-bootstrap';
import { ApartmentStatusDirective } from '@common/directive/apartment-status.directive';
import { ResourceByIdPipe } from '@shared/pipes/resource-by-id.pipe';
import { ApartmentStatus } from '@shared/enums/ApartmentStatus';
import { PropertyStatusDirective } from "@common/directive/property-status.directive";
import { PropertiesService } from '@modules/settings/properties/properties.service';
import {
  PropertyApartmentCardComponent
} from '@modules/universal-billing/properties/properties-table/property-apartment-card/property-apartment-card.component';
import { Observable } from 'rxjs';
import { PageResult } from '@shared/components/classes/page-result';


@Component({
  selector: 'app-properties-table',
  standalone: true,
  imports: [
    PTableCellValueComponent,
    SharedModule,
    Table,
    TranslatePipe,
    SelectableRow,
    NgClass,
    RouterLink,
    PersonalPropertyInfoComponent,
    NgIf,
    NgbAccordionDirective,
    NgbAccordionItem,
    NgbAccordionHeader,
    NgbAccordionButton,
    NgbAccordionCollapse,
    NgbAccordionBody,
    NgForOf,
    ApartmentStatusDirective,
    ResourceByIdPipe,
    ApartmentStatusDirective,
    PropertyStatusDirective,
    PropertyApartmentCardComponent,
    DatePipe
  ],
  templateUrl: './properties-table.component.html',
  styleUrl: './properties-table.component.scss'
})
export class PropertiesTableComponent extends BasicTableComponent<any> implements OnInit {
  public service = inject(PropertiesService);
  public expandedRows: { [key: string]: boolean } = {};
  @Input() type: 'card' | 'table' = 'card';
  @Input() customParams = {};
  apartmentsFields: ReferenceField[] = [
    idField,
    {fieldName: 'code', label: 'RESIDENTS.CODE', iconClass: 'las la-hashtag'},
    {fieldName: 'floor', label: 'APARTMENT.FLOOR', iconClass: 'las la-layer-group'},
    {fieldName: 'number', label: 'APARTMENT.NUMBER', iconClass: ''},
    {fieldName: 'numberOfResidents', label: 'APARTMENT.NUMBER_OF_RESIDENTS', iconClass: ''},
    {fieldName: 'size', label: 'APARTMENT.SIZE_SQM', iconClass: ''},
    {fieldName: 'status', label: 'CITY.STATUS', viewType: 'status', iconClass: 'las la-toggle-on'},
  ];
  protected router = inject(Router);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  onView(data: any) {
    this.router.navigate([getResourceById(Resources.PropertiesProfile, data.id)]);
  }

  toggleRow(row: any) {
    this.expandedRows[row.id] = !this.expandedRows[row.id];
  }

  isExpanded(row: any): boolean {
    return this.expandedRows[row.id];
  }

  onApartmentView(data: any) {
    this.router.navigate([getResourceById(Resources.UniversalBillingApartmentsProfile, data.id)]);
  }

  getOccupiedApartmentsPercent(property) {
    return Math.floor(100 * property.apartments.filter(apt => apt.isVacant == ApartmentStatus.OCCUPIED).length / property.apartments.length) || 0;
  }
  public triggerGlobalSearch(term: string) {
    if (!this.lastTableLazyLoadEvent) return;
    this.lastTableLazyLoadEvent.globalFilter = term;
    this.lastTableLazyLoadEvent.first = 0;
    this.loadData(this.lastTableLazyLoadEvent);
  }
  getAll(params: object): Observable<PageResult<any>> {
    return super.getAll({ ...params, ...this.customParams});
  }
}
